import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './task-list-constants';
import * as actions from './task-list-actions';

export function* getTaskList(action) {
  try {
    const { orderId, taskListId } = action.payload;
    const results = yield call(callApi, {
      endpoint: `info/tasklist/order/${orderId}?taskListId=${taskListId}`,
      options: {
        method: 'GET',
        errorMessage: 'Could not get tasklist',
        retryAction: action,
      },
    });

    yield put(actions.getTaskListSuccess(results));
  } catch (err) {
    yield put(actions.getTaskListFailure(err));
  }
}

function* watchGetTaskList() {
  yield takeLatest(types.GET_TASKLIST_REQUEST, getTaskList);
}

export default [fork(watchGetTaskList)];
